import { useEffect, useRef } from 'react'

/**
 * Run `fire` once per mount. `main.tsx` mounts under StrictMode, which runs
 * every effect twice in dev; the ref survives that simulated remount, so a
 * `*_viewed` event is not counted twice. The same mechanism as
 * `useScreenViewed`, for screens with nothing to wait for.
 */
export function useOnce(fire: () => void): void {
  const fired = useRef(false)
  useEffect(() => {
    if (fired.current) return
    fired.current = true
    fire()
  }, [fire])
}
